/**
 * @module business 
 *  Apis must need auth details to trigger url - AuthApi
 */

import store from '@/store/index';
import Env from '@/env';
const apiVersion = 'api';
import AuthApis from '@/controllers/AuthApis';
import Helpers from '@/helpers';
import ApiHelper from '@/controllers/ApiHelpers';

export default {
  /*
   * fetch all the promotions
   */
  fetchAll(isPagination=true, page = 1, perPage = 10) {
    let url = `${Env.productUrl}/api/ai-purchase-order-prompts/get-all`;
    if(isPagination){
      url += `?page=${page}&perPage=${perPage}`
    }else{
      url += `?isPagination=${isPagination}`
    }
    return AuthApis.getApi(url, {
      api_token: Env.productApiToken,
      'Authorization': 'Bearer ' + store.getters['auth/userToken'],
    }).then((response) => {
      return response;
    }).catch((err) => {
      ApiHelper.detectStatusAndRedirect(err);
      return err;
    })
  },


  /*
   * add new purchase order ai
   */
  async addPoAI(data) {
    data = await Helpers.setEmptyValueToNull(data);
    const url = `${Env.productUrl}/api/ai-purchase-order-prompts/create`;
    return AuthApis.postApi(url, {
        'Authorization': 'Bearer ' + store.getters['auth/userToken'],
        api_token: Env.productApiToken,
      }, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


  /*
   * Update purchase order ai
   */
  async updatePoAI(id, data) {
    data = await Helpers.setEmptyValueToNull(data);
    const url = `${Env.productUrl}/api/ai-purchase-order-prompts/update/${id}`;
    return AuthApis.putApi(url, {
        'Authorization': 'Bearer ' + store.getters['auth/userToken'],
        api_token: Env.productApiToken,
      }, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

  sortPoAI(data){
    const url = `${Env.productUrl}/api/ai-purchase-order-prompts/updateSortOrder`;
    return AuthApis.putApi(url, {
        'Authorization': 'Bearer ' + store.getters['auth/userToken'],
        api_token: Env.productApiToken,
      }, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


  /*
   * Delete
   */
  delete(id) {
    const url = `${Env.productUrl}/api/ai-purchase-order-prompts/delete/${id}`;
    return AuthApis.deleteApi(url, {
        'Authorization': 'Bearer ' + store.getters['auth/userToken'],
        api_token: Env.productApiToken,
      })
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

}